"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M-1468-1237H452v2638h-1920z"
  }), __jsx("path", {
    d: "M16.39 5.82a1.003 1.003 0 00-.937-.654h-4.058a.333.333 0 01-.315-.223L9.623.815a1 1 0 00-1.873 0l-.003.01-1.454 4.118a.333.333 0 01-.314.223H1.92a1 1 0 00-.642 1.767L4.734 9.8a.333.333 0 01.103.362l-1.452 4.354a1 1 0 001.54 1.123l3.564-2.614a.333.333 0 01.394 0l3.563 2.613a1 1 0 001.541-1.122l-1.452-4.357a.333.333 0 01.104-.362l3.462-2.87a1 1 0 00.29-1.108z",
    fillRule: "nonzero",
    fill: "currentColor"
  })));
}
var _default = exports.default = SvgComponent;